import { createSlice } from '@reduxjs/toolkit'
import {getEntryChannels, getEntryChannelsPag} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  entryChannels: [], 
  entryChannelsPag: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: []
  }, 
  loading: "idle",
  loadingPag: "idle",
  error: null }

const entryChannelsSlice = createSlice({
  name: 'entryChannels',
  initialState,
  reducers: {
    clearEntryChannelsError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getEntryChannels.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getEntryChannels.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.entryChannels = action.payload
    },
    [getEntryChannels.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [getEntryChannelsPag.pending]: (state) => {
        state.loading = "loadingPag"; 
        state.error = null
    },
    [getEntryChannelsPag.fulfilled]: (state, action) => {
    state.loadingPag = "succeeded";
    state.entryChannelsPag.elements = action.payload.elements
    state.entryChannelsPag.pageIndex = action.payload.pageIndex;
    state.entryChannelsPag.pageSize = action.payload.pageSize;
    state.entryChannelsPag.totalRecords = action.payload.totalRecords;
    state.entryChannelsPag.totalPages = action.payload.totalPages;
    state.entryChannelsPag.hasPreviousPage = action.payload.hasPreviousPage;
    state.entryChannelsPag.hasNextPage = action.payload.hasNextPage
      
    },
    [getEntryChannelsPag.rejected]: (state, action) => {
        state.loadingPag = "failed"; 
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearEntryChannelsError} = entryChannelsSlice.actions;
export default entryChannelsSlice.reducer
